import React, { useState, useEffect, useRef } from "react";
import { Carousel, Image, Modal } from 'antd';
import { ImageType } from "./photos";
import { FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { MdClose } from "react-icons/md";

interface PhotoAlbumType {
    source: ImgSourceType;
}
interface ImgSourceType {
    miniImages: ImageType[] | any[];
    largeImages: ImageType[] | any[];
}

const PhotoAlbum = (props: PhotoAlbumType) => {
    const [isLightboxVisible, setIsLightboxVisible] = useState(false);

    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const carouselRef = useRef<any>(null);

    const handleImageClick = (index: number) => {
        console.log("gogo currentındex: ", index);
        setCurrentImageIndex(index);
        setIsLightboxVisible(true);
    };

    const handleClose = () => {
        setIsLightboxVisible(false);
    };

    useEffect(() => {
        if (isLightboxVisible && carouselRef.current) {
            carouselRef.current.goTo(currentImageIndex, true);
        }
    }, [isLightboxVisible, currentImageIndex]);

    console.log("gogo currentImageIndex", currentImageIndex)

    return (
        <div className="photo-album__content">
            {props.source.miniImages.map((item: ImageType, index: number) => (
                <div className="photo-album__mini-image-content">
                    <Image
                        preview={false}
                        key={index}
                        width={312}
                        height={300}
                        src={item.src}
                        style={{
                            flex: '0 0 calc(33.333% - 10px)',
                            width: '100%',
                            cursor: 'pointer',
                        }}
                        onClick={() => handleImageClick(index)}
                    />
                </div>
            ))}

            <Modal
                open={isLightboxVisible}
                onCancel={handleClose}
                footer={null}
                centered
                width={1250}
                className="photo-album__lightbox"
                maskStyle={{ background: "rgba(0, 0, 0, 0.93)" }}
                closeIcon={<MdClose color="#fff" fontWeight={700} fontSize={32} />}
                maskClosable={false}
            >
                <Carousel
                    ref={carouselRef}
                    arrows={true}
                    prevArrow={<FaArrowLeft fontSize={28} fontWeight={600} color="#fff" />}
                    nextArrow={<FaArrowRight fontSize={28} fontWeight={600} color="#fff" />}
                    autoplay={false}
                    initialSlide={currentImageIndex}
                    afterChange={(index) => setCurrentImageIndex(index)}
                    dots={false}
                >
                    {props.source.largeImages.map((item: ImageType, index: number) => (
                        <div key={index}>
                            <Image
                                preview={false}
                                src={item.src}
                            />
                        </div>
                    ))}
                </Carousel>

            </Modal>
        </div>
    );
}

export default PhotoAlbum;
